const Profile = () => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 20C5.33579 17.5226 8.50702 16 12 16C15.493 16 18.6642 17.5226 21 20"
      stroke="CurrentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 12C14.4853 12 16.5 9.98528 16.5 7.5C16.5 5.01472 14.4853 3 12 3C9.51472 3 7.5 5.01472 7.5 7.5C7.5 9.98528 9.51472 12 12 12Z"
      stroke="CurrentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Setting = () => (
  <>
    {" "}
    <svg
      width={18}
      height={18}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_44_60)">
        <path
          d="M11.5 14.375C13.0878 14.375 14.375 13.0878 14.375 11.5C14.375 9.91218 13.0878 8.625 11.5 8.625C9.91218 8.625 8.625 9.91218 8.625 11.5C8.625 13.0878 9.91218 14.375 11.5 14.375Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M18.5917 14.3749C18.4641 14.664 18.4261 14.9846 18.4824 15.2955C18.5388 15.6064 18.687 15.8932 18.9079 16.1191L18.9654 16.1766C19.1436 16.3546 19.285 16.566 19.3815 16.7987C19.4779 17.0313 19.5276 17.2807 19.5276 17.5326C19.5276 17.7845 19.4779 18.0339 19.3815 18.2666C19.285 18.4993 19.1436 18.7107 18.9654 18.8887C18.7874 19.0669 18.576 19.2082 18.3434 19.3047C18.1107 19.4012 17.8613 19.4508 17.6094 19.4508C17.3575 19.4508 17.1081 19.4012 16.8754 19.3047C16.6427 19.2082 16.4313 19.0669 16.2533 18.8887L16.1958 18.8312C15.97 18.6102 15.6831 18.462 15.3722 18.4057C15.0614 18.3493 14.7407 18.3874 14.4517 18.5149C14.1682 18.6364 13.9265 18.8381 13.7562 19.0952C13.5859 19.3523 13.4946 19.6536 13.4933 19.962V20.1249C13.4933 20.6333 13.2914 21.1208 12.932 21.4802C12.5725 21.8397 12.085 22.0416 11.5767 22.0416C11.0683 22.0416 10.5808 21.8397 10.2214 21.4802C9.86194 21.1208 9.66001 20.6333 9.66001 20.1249V20.0387C9.65259 19.7215 9.54992 19.4138 9.36533 19.1558C9.18075 18.8977 8.9228 18.7011 8.62501 18.5916C8.33596 18.464 8.01533 18.426 7.70445 18.4823C7.39357 18.5387 7.1067 18.6869 6.88084 18.9078L6.82334 18.9653C6.64534 19.1435 6.43395 19.2849 6.20127 19.3814C5.96859 19.4778 5.71918 19.5275 5.4673 19.5275C5.21542 19.5275 4.96601 19.4778 4.73333 19.3814C4.50065 19.2849 4.28927 19.1435 4.11126 18.9653C3.93306 18.7873 3.79168 18.5759 3.69523 18.3433C3.59877 18.1106 3.54913 17.8612 3.54913 17.6093C3.54913 17.3574 3.59877 17.108 3.69523 16.8753C3.79168 16.6426 3.93306 16.4313 4.11126 16.2533L4.16876 16.1958C4.38969 15.9699 4.5379 15.683 4.59426 15.3721C4.65063 15.0613 4.61258 14.7406 4.48501 14.4516C4.36353 14.1681 4.16182 13.9264 3.90471 13.7561C3.64759 13.5859 3.34631 13.4945 3.03793 13.4933H2.87501C2.36668 13.4933 1.87917 13.2913 1.51972 12.9319C1.16028 12.5724 0.958344 12.0849 0.958344 11.5766C0.958344 11.0683 1.16028 10.5807 1.51972 10.2213C1.87917 9.86185 2.36668 9.65992 2.87501 9.65992H2.96126C3.27846 9.6525 3.5861 9.54982 3.84417 9.36524C4.10225 9.18066 4.29882 8.92271 4.40834 8.62492C4.53591 8.33587 4.57397 8.01523 4.5176 7.70435C4.46123 7.39348 4.31302 7.10661 4.09209 6.88075L4.03459 6.82325C3.85639 6.64525 3.71502 6.43386 3.61856 6.20118C3.52211 5.9685 3.47246 5.71909 3.47246 5.46721C3.47246 5.21533 3.52211 4.96592 3.61856 4.73324C3.71502 4.50056 3.85639 4.28918 4.03459 4.11117C4.2126 3.93296 4.42399 3.79159 4.65667 3.69514C4.88935 3.59868 5.13876 3.54904 5.39064 3.54904C5.64252 3.54904 5.89192 3.59868 6.1246 3.69514C6.35728 3.79159 6.56867 3.93296 6.74668 4.11117L6.80418 4.16867C7.03004 4.3896 7.3169 4.5378 7.62778 4.59417C7.93866 4.65054 8.2593 4.61249 8.54834 4.48492H8.62501C8.90846 4.36344 9.15019 4.16173 9.32047 3.90461C9.49074 3.6475 9.58211 3.34621 9.58334 3.03784V2.87492C9.58334 2.36659 9.78528 1.87908 10.1447 1.51963C10.5042 1.16019 10.9917 0.958252 11.5 0.958252C12.0083 0.958252 12.4959 1.16019 12.8553 1.51963C13.2147 1.87908 13.4167 2.36659 13.4167 2.87492V2.96117C13.4179 3.26955 13.5093 3.57084 13.6796 3.82795C13.8498 4.08506 14.0916 4.28677 14.375 4.40825C14.6641 4.53582 14.9847 4.57387 15.2956 4.51751C15.6065 4.46114 15.8933 4.31293 16.1192 4.092L16.1767 4.0345C16.3547 3.8563 16.5661 3.71493 16.7988 3.61847C17.0314 3.52202 17.2808 3.47237 17.5327 3.47237C17.7846 3.47237 18.034 3.52202 18.2667 3.61847C18.4994 3.71493 18.7108 3.8563 18.8888 4.0345C19.067 4.21251 19.2083 4.4239 19.3048 4.65657C19.4012 4.88925 19.4509 5.13866 19.4509 5.39054C19.4509 5.64242 19.4012 5.89183 19.3048 6.12451C19.2083 6.35719 19.067 6.56858 18.8888 6.74659L18.8313 6.80409C18.6103 7.02994 18.4621 7.31681 18.4058 7.62769C18.3494 7.93857 18.3874 8.2592 18.515 8.54825V8.62492C18.6365 8.90836 18.8382 9.1501 19.0953 9.32037C19.3524 9.49065 19.6537 9.58202 19.9621 9.58325H20.125C20.6333 9.58325 21.1209 9.78519 21.4803 10.1446C21.8397 10.5041 22.0417 10.9916 22.0417 11.4999C22.0417 12.0083 21.8397 12.4958 21.4803 12.8552C21.1209 13.2147 20.6333 13.4166 20.125 13.4166H20.0388C19.7304 13.4178 19.4291 13.5092 19.172 13.6795C18.9149 13.8497 18.7132 14.0915 18.5917 14.3749Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_44_60">
          <rect width="23" height="23" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </>
);

const Plan = () => (
  <>
    <svg
      width={18}
      height={18}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 10H2M22 11V8.2C22 7.0799 22 6.51984 21.782 6.09202C21.5903 5.7157 21.2843 5.40974 20.908 5.21799C20.4802 5 19.9201 5 18.8 5H5.2C4.0799 5 3.51984 5 3.09202 5.21799C2.7157 5.40973 2.40973 5.71569 2.21799 6.09202C2 6.51984 2 7.0799 2 8.2V15.8C2 16.9201 2 17.4802 2.21799 17.908C2.40973 18.2843 2.71569 18.5903 3.09202 18.782C3.51984 19 4.07989 19 5.2 19H11.5M18 21C18 21 21 19.5701 21 17.4252V14.9229L18.8124 14.1412C18.2868 13.9529 17.712 13.9529 17.1864 14.1412L15 14.9229V17.4252C15 19.5701 18 21 18 21Z"
        stroke="CurrentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </>
);
export { Profile, Setting, Plan };
